import { useLazyQuery } from "@apollo/client";
import { ASSISTANT_LOGS } from "@repo-sapiens/graphql";
import { fakeLogs } from "../../../demo-data";
import { useDemoMode } from "../../../hooks";
import { useEffect, useState } from "react";
import { EALogsResponse } from "../../../types";

export const useActivity = () => {
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [logs, setLogs] = useState<EALogsResponse["assistantLogs"]>([]);
  const { demoMode } = useDemoMode();
  const [fetchLogs, { loading, error, startPolling, refetch }] =
    useLazyQuery<EALogsResponse>(ASSISTANT_LOGS, {
      //pollInterval: demoMode ? undefined : 10000,
    });

  const loadMoreItems = async () => {
    if (logs?.length > 0 && hasMore) {
      setPage((prev) => prev + 1);
    }
  };

  const removeDuplicates = (arr: EALogsResponse["assistantLogs"]) => {
    return arr.filter((v, i, a) => a.findIndex((t) => t._id === v._id) === i);
  };

  useEffect(() => {
    if (!demoMode) {
      fetchLogs({
        fetchPolicy: "network-only",
        nextFetchPolicy: "cache-first",
        variables: {
          page,
        },
      }).then((res) => {
        if (res.data) {
          // setLogs((prev) => [...prev, ...(res?.data?.assistantLogs || [])]);
          setLogs((prev) =>
            removeDuplicates([...prev, ...(res?.data?.assistantLogs || [])]),
          );
          setHasMore(res?.data?.assistantLogs?.length === 3);
          if (page === 0) {
            setPage(1);
          }
        }
      });
    } else {
      setLogs(fakeLogs);
    }
  }, [demoMode, fetchLogs, page, startPolling]);

  return {
    logs,
    loading,
    error,
    refetch,
    loadMoreItems,
  };
};
